import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

const ImportModal = ({ show, onHide, onSubmit }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState('');
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validasi tipe file (contoh: hanya menerima excel)
      const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      if (validTypes.includes(file.type)) {
        setSelectedFile(file);
        setError('');
      } else {
        setSelectedFile(null);
        setError('Format file tidak valid. Silakan pilih file Excel (.xls atau .xlsx)');
      }
    }
  };
  
  const handleSubmit = () => {
    if (!selectedFile) {
      setError('Silakan pilih file terlebih dahulu');
      return;
    }
    
    onSubmit(selectedFile);
  };
  
  const handleClose = () => {
    setSelectedFile(null);
    setError('');
    onHide();
  };
  
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Import Data Dapodik</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        
        <Form>
          <Form.Group>
            <Form.Label>Pilih File Excel</Form.Label>
            <Form.Control 
              type="file" 
              accept=".xls,.xlsx" 
              onChange={handleFileChange}
            />
            <Form.Text className="text-muted">
              Format file yang didukung: .xls, .xlsx
            </Form.Text>
          </Form.Group>
          
          {selectedFile && (
            <div className="mt-3">
              <strong>File terpilih:</strong> {selectedFile.name}
            </div>
          )}
          
          <div className="mt-4">
            <h6>Petunjuk:</h6>
            <ol className="pl-3">
              <li>Unduh template Excel <a href="#" className="text-primary">di sini</a></li>
              <li>Isi data sesuai format yang ditentukan</li>
              <li>Simpan file dan unggah melalui form di atas</li>
            </ol>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Batal
        </Button>
        <Button 
          variant="primary" 
          onClick={handleSubmit}
          disabled={!selectedFile}
        >
          Import
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportModal;